import { useState } from "react";
import { useAuth } from "@/components/auth/AuthProvider";
import { ConversationsList } from "./ConversationsList";
import { MessagesList } from "./MessagesList";
import { MessageInput } from "./MessageInput";
import { useConversations } from "@/hooks/useConversations";
import { useMessages } from "@/hooks/useMessages";

export function ChatInterface() {
  const { user } = useAuth();
  const [message, setMessage] = useState("");
  
  const {
    conversations,
    currentConversation,
    setCurrentConversation,
    createNewConversation,
  } = useConversations(user);

  const {
    messages,
    isLoading,
    sendMessage,
  } = useMessages(user, currentConversation);

  const handleSendMessage = async () => {
    if (!currentConversation) {
      console.log('No conversation selected, creating new conversation');
      const newConversationId = await createNewConversation();
      if (newConversationId !== null) {
        console.log('New conversation created:', newConversationId);
        setCurrentConversation(newConversationId);
        if (message.trim()) {
          await sendMessage(message);
          setMessage("");
        }
      }
    } else if (message.trim()) {
      console.log('Sending message to existing conversation:', currentConversation);
      await sendMessage(message);
      setMessage("");
    }
  };

  const handleConversationSelect = (conversationId: string) => {
    console.log('Selecting conversation:', conversationId);
    setCurrentConversation(conversationId);
  };

  return (
    <div className="flex h-[calc(100vh-4rem)] gap-4 p-4">
      <ConversationsList
        conversations={conversations}
        currentConversation={currentConversation}
        onConversationSelect={handleConversationSelect}
        onNewConversation={createNewConversation}
      />
      <div className="flex-1 flex flex-col gap-4">
        <MessagesList messages={messages} />
        <MessageInput
          message={message}
          isLoading={isLoading}
          onMessageChange={setMessage}
          onSendMessage={handleSendMessage}
        />
      </div>
    </div>
  );
}